export const TRANSPORT_SEARCH_ALLOWED_MAX_LENGTH = 40;
